<template>
  <div class="slideVerif">
    <button
      id="tencentVerify"
      class="frame_box pr tencentVerify iconfont"
      v-if="checkType == 'tencent'"
      :disabled="checkedTencent"
      :class="{ disalbedTencent: checkedTencent }"
      type="button"
      @click="tengXun"
      :data-appid="appKey"
    >
      {{ !checkedTencent ? "点此进行验证" : "&#xe730; 验证成功" }}
    </button>
    <div id="safeVerify" v-else></div>
  </div>
</template>
<script>
import { GetSlideVerifyToken, GetSlideVerifyType, geetestRegister } from "../../service/getData";
import { Toast } from "mint-ui";
import getUa  from "../../utils/getUa"
export default {
  data() {
    return {
      slideVerifyToken: "",
      safeChecked: false,
      appKey: "",
      checkType: "",
      checkedTencent: false,
      verifyToken: "",
      TencentSafe: ""
    };
  },
  methods: {
    client(){
      let client = getUa.userAgent.badfish ? 'xyh5': (getUa.userAgent.iswechat ? 'wxh5':( this.isPc() ? 'pc' : 'h5' ));
      return client
    },
    isPc(){
      let sUserAgent= navigator.userAgent.toLowerCase();

      let bIsIpad= sUserAgent.match(/ipad/i) == "ipad";

      let bIsIphoneOs= sUserAgent.match(/iphone os/i) == "iphone os";

      let bIsInnerApp= sUserAgent.match(/xzapp\/ios/i) == "xzapp/ios";

      let bIsMidp= sUserAgent.match(/midp/i) == "midp";

      let bIsUc7= sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";

      let bIsUc= sUserAgent.match(/ucweb/i) == "ucweb";

      let bIsAndroid= sUserAgent.match(/android/i) == "android";

      let bIsCE= sUserAgent.match(/windows ce/i) == "windows ce";

      let bIsWM= sUserAgent.match(/windows mobile/i) == "windows mobile";

      return !(bIsIpad || bIsIphoneOs || bIsInnerApp || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM);
    },
    checkToken(datas) {
      const that = this;
      const params = datas;
      // 公共参数设置
      params.use = "biz";
      params.token = that.verifyToken;
      params.scene = "login";
      params.client = this.client()
      that.$get(GetSlideVerifyToken, params).then(res => {
        if (res.status == 200 && res.content) {
          that.slideVerifyToken = res.content.slideToken;
          that.safeChecked = true;
        } else {
          Toast("验证失败，请重新验证");
          // 1.5秒后重新加载验证
          setTimeout(function() {
            that.getVerifyType();
          }, 1500);
        }
      });
    },
    aliYun() {
      const safeScript = document.createElement("script");
      safeScript.type = "text/javascript";
      safeScript.src = "https://g.alicdn.com/sd/ncpc/nc.js?t=2015052012";
      document.body.appendChild(safeScript);
      safeScript.onload = () => {
        const that = this;
        const nc_token = ["CF_APP_1", new Date().getTime(), Math.random()].join(
          ":"
        );
        var NC_Opt = {
          renderTo: "#safeVerify",
          appkey: that.appKey,
          scene: "nc_register_h5",
          token: nc_token,
          customWidth: "100%",
          trans: { key1: "code0" },
          elementID: ["usernameID"],
          is_Opt: 0,
          language: "cn",
          isEnabled: true,
          timeout: 3000,
          times: 5,
          apimap: {},
          callback: function(data) {
            // 验证token
            const params = {
              slideVerifyType: "aliyun",
              slideVerifyToken: nc_token,
              slideVerifyScene: NC_Opt.scene,
              slideVerifySessionId: data.csessionid,
              slideVerifySig: data.sig,
              busiKey: "register"
            };
            that.checkToken(params);
          }
        };
        const nc = new noCaptcha(NC_Opt);
        nc.upLang("cn", {
          _startTEXT: "请按住滑块，拖动到最右边",
          _yesTEXT: "验证通过",
          _error300:
            '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
          _errorNetwork:
            '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
        });
      };
    },
    wangYi() {
      const that = this;
      const safeScript = document.createElement("script");
      safeScript.type = "text/javascript";
      safeScript.src = "https://cstaticdun.126.net/load.min.js";
      document.body.appendChild(safeScript);
      safeScript.onload = () => {
        initNECaptcha(
          {
            // 网易key
            captchaId: that.appKey,
            // 网易验证码容器
            element: "#safeVerify",
            mode: "float",
            width: "100%",
            onReady: function(instance) {},
            onVerify: function(err, data) {
              that.NECaptchaValidate = (data && data.validate) || "";
              // 向后端换取token
              const params = {
                slideVerifyType: "yidun",
                NECaptchaValidate: that.NECaptchaValidate,
                busiKey: "register"
              };
              that.checkToken(params);
            }
          },
          function onload(instance) {},
          function onerror(err) {
            Toast("验证失败，请重新验证");
          }
        );
      };
    },
    tengXun() {
      const that = this;
      const TencentCaptcha1 = new TencentCaptcha(that.appKey, function(res) {
        if (res.ret === 0) {
          const params = {
            ticket: res.ticket,
            slideVerifyType: "tencent",
            randstr: res.randstr
          };
          that.checkedTencent = true;
          that.checkToken(params);
        }
      });
      TencentCaptcha1.show();
    },
    initGeetest(res){
      const that = this;
        initGeetest({
          // 省略配置参数
          api_server:'api.geevisit.com',
          gt: res.gt,
          challenge: res.challenge,
          offline: !res.success,
          new_captcha: true,
          width: '340px',
        }, function (captchaObj) {
          captchaObj.onReady(function(){
            document.getElementById('safeVerify').innerHTML = ''
            captchaObj.appendTo('#safeVerify');
            //your code
          }).onSuccess(function(){
            var result = captchaObj.getValidate();
            console.log(result,'result');
            if (!result) {
              return Toast('请完成验证');
            }
            const params = {
              slideVerifyType: that.checkType,
              geetest_challenge:result.geetest_challenge,
              geetest_validate:result.geetest_validate,
              geetest_seccode: result.geetest_seccode,
              client:'H5'
            }
            that.checkToken(params);
          })
        });


    },
    geetest(){
      const that = this;
      that.$get(geetestRegister,{scene:'login',client:'H5'}).then(data=>{
        let res = data.content
        that.initGeetest(res)
      })

    },
    loadJs(src,callback){
      var script = document.createElement('script'),
        head = document.getElementsByTagName('head')[0];
      script.type = 'text/javascript';
      script.charset = 'UTF-8';
      script.src = src;
      if (script.addEventListener) {
        script.addEventListener('load', function () {
          callback();
        }, false);
      } else if (script.attachEvent) {
        script.attachEvent('onreadystatechange', function () {
          var target = window.event.srcElement;
          if (target.readyState == 'loaded') {
            callback();
          }
        });
      }
      head.appendChild(script);
    },
    showType() {
      const that = this;
      if (this.checkType == "aliyun") {
        this.aliYun();
      } else if (this.checkType == "yidun") {
        this.wangYi();
      } else if (this.checkType == "tencent") {
        this.checkedTencent = false;
        // this.tengXun()
      } else if(this.checkType == "geetest"){
        this.loadJs('/static/js/gt.js',function () {
          that.geetest()
        })
      }
      else{
        this.loadJs('/static/js/gt.js',function () {
          that.geetest()
        })
      }
    },
    getVerifyType() {
      // 获取类型
      const that = this;
      that.$get(GetSlideVerifyType, { use: "biz",client: this.client(),scene:'login' }).then(res => {
        if (res.status !== 200) return Toast(res.errorMsg);
        if (res.content) {
          that.checkType = res.content.type;
          if (that.checkType == "tencent") {
            // 加载腾讯js
            if (window.TencentCaptcha === undefined) {
              const script = document.createElement("script");
              const head = document.getElementsByTagName("head")[0];
              script.type = "text/javascript";
              script.charset = "UTF-8";
              script.src = "https://ssl.captcha.qq.com/TCaptcha.js";
              head.appendChild(script);
            }
          }
          this.appKey = res.content.appKey;
          // 判断展示类型
          this.showType();
          if (res.content.token) {
            that.verifyToken = res.content.token;
          }
        }
      });
    }
  },
  created() {
    if (sessionStorage.getItem("isAutoTest")) {
      this.safeChecked = true;
    }
    this.getVerifyType();
  },
  mounted() {},
  beforeDestroy() {
    const that = this;
    try {
      document.body.removeChild(that.safeScript);
    } catch (e) {}
  }
};
</script>

<style lang="scss">
.nc-container .nc_scale span {
  height: 34px !important;
}
.slideVerif {
  .tencentVerify {
    text-align: center;
    background: linear-gradient(180deg, #fff 0, #ebedf0 87%);
    border: 1px solid #e4e7eb;
  }
  .disalbedTencent {
    border: 2px solid #52ccba;
    background: #d2f4ef;
    color: #52ccba;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/safeVerify/safeVerify.vue